import { useGetFeatureFlagsQuery } from '@/state/slices/featureFlags';

/** Keys of the flags in the backend registry, camelCased as the API returns them. */
export type FlagKey = 'autosave' | 'phaseIndicators';

/**
 * Whether a feature flag is on for the current user. Off while loading, on
 * error, and for a key the API doesn't return, so gated UI never flashes in.
 * All callers share one cached request.
 *
 *   if (!useFlag('autosave')) return null;
 */
export function useFlag(key: FlagKey): boolean {
  const { data } = useGetFeatureFlagsQuery();
  return data?.[key] ?? false;
}
